import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CompanyInfo } from '../model/company-info.model';
import { AppConfiguration } from '../../core/models/app-configuration.model';

/**
 * User Info Service
 * @description Angular service used for retrieve and update user information
 */
@Injectable({ providedIn: 'root' })
export class CompanyService {
  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfiguration) { }
  getResourceUrl(): string {
    return this.appConfig.serverApiUrl + '/api/v1/holder/info';
  }

  public query(): Observable<CompanyInfo> {
    return this.http.get<CompanyInfo>(this.getResourceUrl());
  }
}
